type Listener = () => void;

const listeners = new Set<Listener>();

export function onSessionTokensChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifySessionTokensChanged(): void {
  listeners.forEach((listener) => listener());
}
